export interface Referral {
  referralId: string;
  referralName: string;
  totalHoursWorked: number;
  hoursWorkedThisWeek: number;
  joinDate: string;
  totalEarnings: number;
}

export interface CreateReferralInvite {
  name: string;
  phoneNumber?: string;
  email: string;
}

export interface ReferralEarningSummary {
  earningsThisWeek: number;
  hoursThisWeek: number;
  totalEarningsAllTime: number;
  totalReferrals: number;
}

export interface ReferralPageDto {
  referrals?: Referral[];
  invitations?: ReferralInvitationListItemDto[];
  referralCode?: string;
  shareableLink?: string;
}

export interface ReferralInvitationListItemDto {
  id: string;
  name: string;
  email: string;
  invitedAt: string;
}
